import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { SearchIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default from 'react';
import useCanvasId from '../../../../utils/useCanvasId.js';

var _excluded = ["id", "className"];

// TODO: Convert to InputWithAdornment?
var ColumnManagerSearchInput = function ColumnManagerSearchInput(_ref) {
  var id = _ref.id,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Input --type-text', className);
  var uuid = useCanvasId(id, 'table-column-search');
  return /*#__PURE__*/React__default.createElement("div", {
    className: finalClasses
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    id: id ? id : uuid,
    type: "text",
    role: "search",
    "aria-label": "search columns",
    placeholder: "Search columns",
    className: "C-ColumnManager__Search__Input"
  }, otherProps)), /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    size: "sm",
    icon: SearchIcon,
    className: "C-ColumnManager__Search__Icon"
  }));
};

export { ColumnManagerSearchInput as default };
